import { client } from '../../../../shared/services/apiClient';
import { PasswordData } from '../models/PasswordData';

export const changePassword = async (data: PasswordData): Promise<any> => {
  return client(true, true)
    .post<any>('/account/change-password', data)
    .then((response) => response.data)
    .catch((error) => error);
};
